module.exports = __webpack_public_path__ + "static/media/guest_list-white-bg.8553f76a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/guest_list-white-bg.svg
// module id = 1750
// module chunks = 50